// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLogo_logo_3JBsI"};